// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      fontWeight: 'bold',
      textAlign: 'center',
    },
    textColor: {
      color: theme.palette.primary.main,
    },
  }),
);

export default useStyles;
